import "./StyleGuide.css";
import "./fonts/stylesheet.css";
import Routing from "./Routing";
import { ToastContainer } from "react-toastify";
import { toastProperties } from "./commons/Toast/Toaster";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./commons/Loader/Loader";
import SocketService from "./commons/Socket/SocketService";
import { handleNotification } from "./handlers/notificationHandler";
import ChatApplication from "./Components/ChatApplication/ChatApplication";
import { chatOpen } from "./Redux/Slices/messageSlice";
import useNetworkStatus from "./hooks/useNetworkStatus";
import NoInternet from "./Components/NoInternet/NoInternet";
import BlockEverything from "./commons/Loader/blockEverything";
import DamStrip from "./Components/Modals/ConGen/Connection/DamStrip";

function App() {
  const dispatch = useDispatch();
  const userId = useSelector(
    (state) => state?.persistedReducer?.user?.user?.userId,
  );
  const chatApp = useSelector((state) => state?.messageSlice);

  const loader = useSelector((state) => state?.notificationSlice?.loading);
  const blockEverything = useSelector(
    (state) => state?.notificationSlice?.blockEverything,
  );
  const activeRole = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  );

  useEffect(() => {
    if (activeRole) {
      document.documentElement.dataset.theme = activeRole;
    } else {
      delete document.documentElement.dataset.theme;
    }
  }, [activeRole]);

  useEffect(() => {
    if (!userId) {
      return;
    }

    const socket = SocketService.getSocket();

    socket.on("connect", () => {
      console.log("Socket connected");
    });

    socket.on("portal-notification", (data) => {
      console.log("Notification Received:", data);
      handleNotification(dispatch, data);
    });

    socket.on("disconnect", () => {
      console.log("Socket disconnected");
    });
    return () => {
      socket.off("portal-notification");
    };
  }, [dispatch, userId]);

  return (
    <div>
      {/* {!isOnline && <NoInternet />} */}
      {chatApp?.chatOpen && chatApp?.chatOpenType === "BILATERAL" && (
        <ChatApplication
          open={chatApp?.chatOpen}
          handleClose={() => dispatch(chatOpen(false))}
          chatId={chatApp?.connectionId}
          fromUsername={chatApp?.fromUser}
          toUsername={chatApp?.toUser}
          header={chatApp?.header}
          hidechat={chatApp?.hidechat}
          tenderName={chatApp?.tenderName}
        />
      )}
      {blockEverything && <BlockEverything />}
      {loader && <Loader />}
      <DamStrip />
      <Routing />
      <ToastContainer style={{ ...toastProperties }} />
    </div>
  );
}

export default App;
